import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { UtilityService } from './utility.service';
import { AngularFireAuth } from 'angularfire2/auth';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class ExtraService {

  private static isSideBar = new BehaviorSubject<boolean>(false);

  private static isLogin = new BehaviorSubject<boolean>(false);

  private static isSideBarButton = new BehaviorSubject<boolean>(false);

  private static currentEventId = new BehaviorSubject<string>(null);

  private static menuTypeSubmit = new BehaviorSubject<boolean>(true);

  castCurrentEventId$ = ExtraService.currentEventId.asObservable();

  cast$:Observable<boolean> = ExtraService.isSideBar.asObservable();

  castLogin$ = ExtraService.isLogin.asObservable();

  castSideBarButton$:Observable<boolean> = ExtraService.isSideBarButton.asObservable();

  castMenuTypeSubmit$ = ExtraService.menuTypeSubmit.asObservable();

  constructor(private utilityService:UtilityService) { }

  public changeStateofSideBar(){
    if(ExtraService.isSideBar.value){
      ExtraService.isSideBar.next(false);
    }else{
      ExtraService.isSideBar.next(true);
    }
  }

  public changeStateofSideBarButton(status :boolean){
      ExtraService.isSideBarButton.next(status);
  }

  public changeSideBar(status :boolean){
    ExtraService.isSideBar.next(status);
}

  public changeStateLogin(){
    
    if(this.utilityService.isLogged()){
      ExtraService.isLogin.next(true);
    }else{
      ExtraService.isLogin.next(false);
    }
    console.log(ExtraService.isLogin.value);
  }

  public setCurrentEventId(id:string){
    ExtraService.currentEventId.next(id);
  }

  public setMenuTypeSubmit(status :boolean){
    ExtraService.menuTypeSubmit.next(status);
  }

}



// WEBPACK FOOTER //
// /workspace/backend-server/src/app/core/services/extra.service.ts